/*
 * Reducer actions related with create case
 */
import * as types from './types';

export function requestCreateAccount(accountRequest) {
  return {
    type: types.CREATE_ACCOUNT_REQUEST,
    accountRequest: accountRequest
  };
}

export function createAccountFailed(error) {
  return {
    type: types.CREATE_ACCOUNT_FAILED,
    error
  };
}

export function onCreateAccountResponse(response) {
  return {
    type: types.CREATE_ACCOUNT_RESPONSE,
    response
  };
}

export function requestGetPhone() {
  return {
    type: types.GET_PHONE_REQUEST
  };
}

export function getPhoneFailed(error) {
  return {
    type: types.GET_PHONE_FAILED,
    error
  };
}

export function onGetPhoneResponse(phone) {
  return {
    type: types.GET_PHONE_RESPONSE,
    phone: phone
  };
}

export function requestUpdateFirstName(firstName) {
  return {
    type: types.UPDATE_FIRSTNAME_REQUEST,
    firstName: firstName
  };
}

export function updateFirstNameFailed(error) {
  return {
    type: types.UPDATE_FIRSTNAME_FAILED,
    error
  };
}

export function onUpdateFirstNameResponse(response) {
  return {
    type: types.UPDATE_FIRSTNAME_RESPONSE,
    response
  };
}

export function requestUpdateLastName(lastName) {
  return {
    type: types.UPDATE_LASTNAME_REQUEST,
    lastName: lastName
  };
}

export function updateLastNameFailed(error) {
  return {
    type: types.UPDATE_LASTNAME_FAILED,
    error
  };
}

export function onUpdateLastNameResponse(response) {
  return {
    type: types.UPDATE_LASTNAME_RESPONSE,
    response
  };
}

export function requestUpdateEmail(email) {
  return {
    type: types.UPDATE_EMAIL_REQUEST,
    email: email
  };
}

export function updateEmailFailed(error) {
  return {
    type: types.UPDATE_EMAIL_FAILED,
    error
  };
}

export function onUpdateEmailResponse(response) {
  return {
    type: types.UPDATE_EMAIL_RESPONSE,
    response
  };
}

export function requestUpdatePhone(phone) {
  return {
    type: types.UPDATE_PHONE_REQUEST,
    phone: phone
  };
}

export function updatePhoneFailed(error) {
  return {
    type: types.UPDATE_PHONE_FAILED,
    error
  };
}

export function onUpdatePhoneResponse(response) {
  return {
    type: types.UPDATE_PHONE_RESPONSE,
    response
  };
}

export function requestUpdatePassword(oldPassword, newPassword) {
  return {
    type: types.UPDATE_PASSWORD_REQUEST,
    password: oldPassword,
    newPassword
  };
}

export function updatePasswordFailed(error) {
  return {
    type: types.UPDATE_PASSWORD_FAILED,
    error
  };
}

export function onUpdatePasswordResponse(newPassword) {
  return {
    type: types.UPDATE_PASSWORD_RESPONSE,
    password: newPassword
  };
}
